<template>
  <!-- b-form-radio rather than a custom segmented control. -->
  <b-form-group v-slot="{ ariaDescribedby }">
    <b-form-radio class="d-inline" :checked="selected" :aria-describedby="ariaDescribedby" name="pit" value="include" @change="onChange">
      {{ $t('pit.includeTestProducts') }}
    </b-form-radio>
    <b-form-radio
      class="d-inline ml-3 mr-3"
      :checked="selected"
      :aria-describedby="ariaDescribedby"
      name="pit"
      value="exclude"
      @change="onChange"
    >
      {{ $t('pit.excludeTestProducts') }}
    </b-form-radio>
    <b-form-radio class="d-inline" :checked="selected" :aria-describedby="ariaDescribedby" name="pit" value="only" @change="onChange">
      {{ $t('pit.onlyTestProducts') }}
    </b-form-radio>
  </b-form-group>
</template>

<script>
import { getUserInfo } from '../../../plugins/authentication'

// Composite CompanyFilter: market/products-in-test segregation
// (exclude=default, include, only). `company` is always the current user's company — never a
// user-chosen field.
export default {
  name: 'companyFilterFilter',
  props: {
    value: { type: Object, default: null },
  },
  computed: {
    selected() {
      if (!this.value) return 'exclude'
      if (this.value.market_products === 'none') return 'only'
      if (this.value.products_in_test === 'include') return 'include'
      return 'exclude'
    },
    userCompany() {
      try {
        const info = JSON.parse(getUserInfo())
        return (info && info.company) || null
      } catch (e) {
        return null
      }
    },
  },
  methods: {
    onChange(mode) {
      if (mode === 'exclude') {
        this.$emit('input', null)
        return
      }
      if (mode === 'include') {
        this.$emit('input', {
          market_products: 'all_companies',
          products_in_test: 'include',
          company: this.userCompany,
        })
        return
      }
      this.$emit('input', {
        market_products: 'none',
        products_in_test: 'include',
        company: this.userCompany,
      })
    },
  },
}
</script>
